import * as integrationsConnectorsQueries from '@Integrations/Connectors/queries-vue-composables'
import * as integrationsDatasetsCommands from '@Integrations/Datasets/commands-vue-composables'
import * as integrationsDatasetsQueries from '@Integrations/Datasets/queries-vue-composables'
import * as integrationsPipelinesCommands from '@Integrations/Pipelines/commands-vue-composables'
import * as integrationsPipelinesQueries from '@Integrations/Pipelines/queries-vue-composables'
import * as integrationsRunsQueries from '@Integrations/Runs/queries-vue-composables'
import * as integrationsUsersQueries from '@Integrations/Users/queries-vue-composables'

export function useAdminConfigurePipelineConnectorPage(){
	return {
		useAttachConnectorCommand: integrationsPipelinesCommands.useAttachConnectorCommandV1,
		useConnectorsOfOrganizationQuery: integrationsConnectorsQueries.useConnectorsOfOrganizationQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
	}
}

export function useAdminConfigurePipelineDatasetPage(){
	return {
		useAttachDatasetCommand: integrationsPipelinesCommands.useAttachDatasetCommandV1,
		useCreateDatasetCommand: integrationsDatasetsCommands.useCreateDatasetCommandV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useDatasetsOfOrganizationQuery: integrationsDatasetsQueries.useDatasetsOfOrganizationQueryV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
	}
}

export function useAdminConfigurePipelineDataStreamPage(){
	return {
		useChangeDataStreamCommand: integrationsPipelinesCommands.useChangeDataStreamCommandV1,
		useConnectorDataStreamsQuery: integrationsConnectorsQueries.useConnectorDataStreamsQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
	}
}

export function useAdminConfigurePipelineIdsPage(){
	return {
		useChangeIdPropertyNameForConnectorCommand: integrationsPipelinesCommands.useChangeIdPropertyNameForConnectorCommandV1,
		useChangeIdPropertyNameForDatasetCommand: integrationsPipelinesCommands.useChangeIdPropertyNameForDatasetCommandV1,
		useChangeIdPropertyNamesForConnectorCommand: integrationsPipelinesCommands.useChangeIdPropertyNamesForConnectorCommandV1,
		useChangeIdPropertyNamesForDatasetCommand: integrationsPipelinesCommands.useChangeIdPropertyNamesForDatasetCommandV1,
		useConnectorPropertyNamesQuery: integrationsConnectorsQueries.useConnectorPropertyNamesQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
	}
}

export function useAdminConfigurePipelineItemFiltersPage(){
	return {
		useAddConnectorItemFilterCommand: integrationsPipelinesCommands.useAddConnectorItemFilterCommandV1,
		useAddDatasetItemFilterCommand: integrationsPipelinesCommands.useAddDatasetItemFilterCommandV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
		useRemoveConnectorItemFilterCommand: integrationsPipelinesCommands.useRemoveConnectorItemFilterCommandV1,
		useRemoveDatasetItemFilterCommand: integrationsPipelinesCommands.useRemoveDatasetItemFilterCommandV1,
	}
}

export function useAdminConfigurePipelineMappingsPage(){
	return {
		useAddPropertyNameMappingCommand: integrationsPipelinesCommands.useAddPropertyNameMappingCommandV1,
		useConnectorPropertyNamesQuery: integrationsConnectorsQueries.useConnectorPropertyNamesQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
		useRemovePropertyNameMappingCommand: integrationsPipelinesCommands.useRemovePropertyNameMappingCommandV1,
	}
}

export function useAdminConfigurePipelinePropertiesPage(){
	return {
		useConnectorPropertyNamesQuery: integrationsConnectorsQueries.useConnectorPropertyNamesQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useDatasetPropertyNamesQuery: integrationsDatasetsQueries.useDatasetPropertyNamesQueryV1,
		useExcludePipelineConnectorPropertyCommand: integrationsPipelinesCommands.useExcludePipelineConnectorPropertyCommandV1,
		useExcludePipelineDatasetPropertyCommand: integrationsPipelinesCommands.useExcludePipelineDatasetPropertyCommandV1,
		useExcludePipelinePropertyCommand: integrationsPipelinesCommands.useExcludePipelinePropertyCommandV1,
		useIncludePipelineConnectorPropertyCommand: integrationsPipelinesCommands.useIncludePipelineConnectorPropertyCommandV1,
		useIncludePipelineDatasetPropertyCommand: integrationsPipelinesCommands.useIncludePipelineDatasetPropertyCommandV1,
		useIncludePipelinePropertyCommand: integrationsPipelinesCommands.useIncludePipelinePropertyCommandV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
		usePipelinePropertyNamesQuery: integrationsPipelinesQueries.usePipelinePropertyNamesQueryV1,
	}
}

export function useAdminCreatePipelinePage(){
	return {
		useConnectorProvidersQuery: integrationsConnectorsQueries.useConnectorProvidersQueryV1,
		useCreatePipelineCommand: integrationsPipelinesCommands.useCreatePipelineCommandV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
	}
}

export function useAdminManagePipelinesPage(){
	return {
		useAllPipelinesQuery: integrationsPipelinesQueries.useAllPipelinesQueryV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
	}
}

export function useAdminPipelineDataPreviewPage(){
	return {
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		usePipelineDataPreviewQuery: integrationsPipelinesQueries.usePipelineDataPreviewQueryV1,
	}
}

export function useAdminPipelineDetailsPage(){
	return {
		useActivatePipelineCommand: integrationsPipelinesCommands.useActivatePipelineCommandV1,
		useAllPipelinesQuery: integrationsPipelinesQueries.useAllPipelinesQueryV1,
		useChangeApplyChangesModeCommand: integrationsPipelinesCommands.useChangeApplyChangesModeCommandV1,
		useChangeClearDatasetOnRunCommand: integrationsPipelinesCommands.useChangeClearDatasetOnRunCommandV1,
		useChangePipelineInternalConnectorTriggerCommandV1: integrationsPipelinesCommands.useChangePipelineInternalConnectorTriggerCommandV1,
		useChangePipelineTimeTriggerRecurrencyCommand: integrationsPipelinesCommands.useChangePipelineTimeTriggerRecurrencyCommandV1,
		useChangePipelineTriggerOnRunCompletedCommand: integrationsPipelinesCommands.useChangePipelineTriggerOnRunCompletedCommandV1,
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useDeactivatePipelineCommand: integrationsPipelinesCommands.useDeactivatePipelineCommandV1,
		useDeletePipelineCommand: integrationsPipelinesCommands.useDeletePipelineCommandV1,
		usePermanentDeletePipelineCommand: integrationsPipelinesCommands.usePermanentDeletePipelineCommandV1,
		usePipelineDetailsQuery: integrationsPipelinesQueries.usePipelineDetailsQueryV1,
		useResetPipelineRunsCommand: integrationsPipelinesCommands.useResetPipelineRunsCommandV1,
		useSetPipelineLogLevelCommand: integrationsPipelinesCommands.useSetPipelineLogLevelCommandV1,
		useTriggerPipelineManuallyCommand: integrationsPipelinesCommands.useTriggerPipelineManuallyCommandV1,
	}
}

export function useAdminPipelinesDashboardPage(){
	return {
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useLastRunsQuery: integrationsRunsQueries.useLastRunsQueryV1,
		usePipelinesDashboardQuery: integrationsPipelinesQueries.usePipelinesDashboardQueryV1,
	}
}

export function usePipelineTriggerPage(){
	return {
		useCurrentUserQuery: integrationsUsersQueries.useCurrentUserQueryV1,
		useLastRunsForPipelineByUserQuery: integrationsRunsQueries.useLastRunsForPipelineByUserQueryV1,
		usePipelineTriggerQuery: integrationsPipelinesQueries.usePipelineTriggerQueryV1,
		useTriggerPipelineManuallyCommand: integrationsPipelinesCommands.useTriggerPipelineManuallyCommandV1,
	}
}

